import React from 'react';
import { Box, Button, Modal, SpaceBetween } from '@amzn/awsui-components-core';

interface CancelWizardModalProps {
  visible: boolean;
  onDismiss: () => void;
  onConfirmCancel: () => void;
}

const CancelWizardModal: React.FC<CancelWizardModalProps> = ({
  visible,
  onDismiss,
  onConfirmCancel,
}) => (
  <Modal
    visible={visible}
    header="Cancel content creation"
    footer={
      <Box float="right">
        <SpaceBetween direction="horizontal" size="xs">
          <Button variant="normal" onClick={onDismiss}>
            Continue on this page
          </Button>
          <Button variant="primary" onClick={onConfirmCancel}>
            Cancel proposal
          </Button>
        </SpaceBetween>
      </Box>
    }
    onDismiss={onDismiss}
    closeAriaLabel="Close modal"
  >
    Your progress in this wizard will not be saved. Do you want to continue?
  </Modal>
);

export default CancelWizardModal;
